import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'sem-daily-challenge-dialog',
    templateUrl: './sem-daily-challenge-dialog.component.html',
    styleUrls: ['./sem-daily-challenge-dialog.component.css'],
    standalone: false
})
export class SemDailyChallengeDialogComponent implements OnInit {

  streakText = '3 dni zapored';
  progressCurrent = 1;
  progressTotal = 3;
  items = [
    { Label: 'Dodaj fotografijo k 5 zapisom', Done: true, Xp: 5 },
    { Label: 'Izpolni manjkajoča obvezna polja', Done: false, Xp: 10 },
    { Label: 'Poveži zapise z avtorjem', Done: false, Xp: 15 }
  ];
  footerActiveText = '3 aktivni ta teden';
  leaderboardLinkText = 'Lestvica →';

  get progressPct(): number {
    return this.progressTotal > 0 ? (this.progressCurrent / this.progressTotal) * 100 : 0;
  }

  constructor(
    public dialogRef: MatDialogRef<SemDailyChallengeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) { }

  ngOnInit(): void {
    this.dialogRef.updateSize('560px', 'auto');
  }

  close() {
    this.dialogRef.close();
  }
}
